import { Box } from '@gousto-internal/citrus-react'
import styled from '@emotion/styled'

export const FourWayImageTile = styled(Box)(() => ({
  borderRadius: '5px 5px 0px 0px',
  overflow: 'hidden',
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
}))

export const ImageWrapper = styled(Box)(() => ({
  aspectRatio: '3/2',
}))
